import { DateTime } from "luxon";

export const formatDateForLoyalty = (endDate) => {
  if (!endDate) {
    return "";
  }

  const parsedDate = DateTime.fromISO(endDate);

  if (!parsedDate.isValid) {
    return "";
  }

  return parsedDate.toFormat("ccc dd MMM");
};
